import { render, staticRenderFns } from "./ContactsCustomer.vue?vue&type=template&id=277c4128&scoped=true"
import script from "./ContactsCustomer.vue?vue&type=script&lang=js"
export * from "./ContactsCustomer.vue?vue&type=script&lang=js"
import style0 from "./ContactsCustomer.vue?vue&type=style&index=0&id=277c4128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c4128",
  null
  
)

export default component.exports